import React, { useState, useRef } from 'react'
import ItemsApp, { IItemModel } from './ItemsApp'
import QRCode, { QRCodeSVG } from "qrcode.react";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Button, Skeleton } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { toPng, toSvg } from "html-to-image";
import { useDispatch } from 'react-redux';
import { handleRequestError } from '../../services/api';
import PrintItemLabelButton from '../printing/PrintItemLabelButton';

interface IProps {
    item: IItemModel,
    loading?: boolean
}

type Props = {
  itemId: number;
  printerKey: string;
  copies?: number;
};

export default function ItemQrCode(props: IProps) {

    const elementRef = useRef<HTMLDivElement | null>(null)
    const dispath = useDispatch()

    const [loadingPrinting, setLoadingPrinting] = React.useState(false)

    const { item, loading } = props
    const { unique_id } = item

    const [downloading, setDownloading] = useState<boolean>(false)

    const id: string = `item-qrcode_${unique_id}`

    const [includeItemName, setIncludeItemName] = useState<boolean>(true)
    const [includeSerialNumber, setIncludeSerialNumber] = useState<boolean>(false)
    const [includeItemUniqueId, setIncludeItemUniqueId] = useState<boolean>(true)

    // const qrCodeElem = document.getElementById(id)

    const fileName: string = `${unique_id} - ${item.title}`

    const saveAsPng = (): void => {
        if (elementRef.current) {
            setDownloading(true)
            toPng(elementRef.current)
                .then((dataUrl: string) => {
                    const link = document.createElement("a");
                    link.href = dataUrl;
                    link.download = fileName + ".png";
                    link.click();

                    setDownloading(false)
                })
                .catch((err: Error) => {
                    console.error("Error saving as PNG:", err);
                    handleRequestError({response: { data: { message: "Error saving as PNG" } }}, dispath)

                    setDownloading(false)
                });
        }
      };
    
      const saveAsSvg = (): void => {
        if (elementRef.current) {
            setDownloading(true)
          toSvg(elementRef.current)
            .then((dataUrl: string) => {
              const link = document.createElement("a");
              link.href = dataUrl;
              link.download = fileName + ".svg";
              link.click();
              setDownloading(false)
            })
            .catch((err: Error) => {
              console.error("Error saving as SVG:", err);
              handleRequestError({response: { data: { message: "Error saving as SVG" } }}, dispath)
              setDownloading(false)
            });
        }
    };

    async function printLabel(itemId:number) {
        const res = await fetch(`/api/printing/items/${itemId}/print-label/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include", // keep this if your auth uses httpOnly cookies
            body: JSON.stringify({
            printer_key: "warehouse_mac_1",
            copies: 1,
            }),
        });

        if (!res.ok) {
            const text = await res.text();
            throw new Error(`Print failed: ${res.status} ${text}`);
        }

        return res.json(); // { job_id, status }
    }

    return(
        <div className="item-qr-code-container">
            <div className="content-of-item-qr-code-container">
                
                <div className="wrapper-of-item-qr-code">
                    <div className="item-qr-code" ref={elementRef} id={id}>
                        <div className="content-of-item-qr-code">
                            {loading ? <Skeleton variant="rectangular" width={256} height={256} /> : <QRCodeSVG value={unique_id} size={256} level="H" />}
                            {includeItemUniqueId ? loading ? <Skeleton variant="text" width="100%" height={20} /> : <h3>{item.unique_id}</h3> : ""}
                            {includeSerialNumber ? loading ? <Skeleton variant="text" width={100} /> : <p><span className="bold-text">SN:</span> {item.serial_number}</p> : ""}
                            {includeItemName ? loading ? <Skeleton variant="text" width={100} /> : <p>{item.title}</p> : ""}
                        </div>
                    </div>
                </div>

                {/* {item.is_container && <a href={`/print/items/qr-codes/${item.unique_id}`} target='_blank'>Print page</a>} */}

                <PrintItemLabelButton itemId={item.id} isItemContainer={item.is_container} />

            </div>
            <div className="action-buttons-of-section-box-admin-panel">
                <div className="content-of-action-buttons-of-section-box-admin-panel">

                    <Button onClick={() => setIncludeItemUniqueId(includeItemUniqueId ? false : true)} className="general-button admin-style light-button" color={includeItemUniqueId ? "error" : "success"} variant="contained">{includeItemUniqueId ? "Hide Unique ID" : "Show Unique ID"}</Button>
                    <Button onClick={() => setIncludeItemName(includeItemName ? false : true)} className="general-button admin-style light-button" color={includeItemName ? "error" : "success"} variant="contained">{includeItemName ? "Hide Item Title" : "Show Item Title"}</Button>
                    <Button onClick={() => setIncludeSerialNumber(includeSerialNumber ? false : true)} className="general-button admin-style light-button" color={includeSerialNumber ? "error" : "success"} variant="contained">{includeSerialNumber ? "Hide Serial Number" : "Show Serial Number"}</Button>

                    <LoadingButton onClick={() => saveAsSvg()} loading={downloading} className="general-button admin-style light-button" color="success" variant="contained">Download as SVG</LoadingButton>
                    <LoadingButton onClick={() => saveAsPng()} loading={downloading} className="general-button admin-style light-button" color="success" variant="contained">Download as PNG</LoadingButton>

                </div>
            </div>
        </div>
    )
}